import React from 'react';
import CampoBuscarEquipo from '../../UI/campos/CampoBuscarEquipo.js';
import CampoEditableCheck from '../../UI/campos/CampoEditableCheck.js';
import CampoEditableMultilinea from '../../UI/campos/CampoEditableMultilinea.js';
import CampoEditableNumero from '../../UI/campos/CampoEditableNumero.js';
import CampoOptionsTitulo from '../../UI/campos/CampoOptionsTitulo.js';
import CampoOptionsMovimiento from '../../UI/campos/CampoOptionsMovimiento.js';
import * as Campos from '../../constantes/Campos.js';
import * as TipoParticipacion from '../../constantes/TipoParticipacionTorneo.js';
import * as TipoEquipo from '../../constantes/TipoEquipo.js';
import styles from '../EditarItemLista.module.css';

const CamposTorneoParticipante = (props) => {
  const item = props.item;
  const editar = props.editar;
  const actualizar = props.actualizar;
  const torneo = props.contexto?.torneo;
  const dePais = torneo && torneo.pais && torneo.pais.id;

  // Determinar tipo de equipo inicial según tipo de participación del torneo
  const tipoParticipacion = torneo?.tipoTorneo?.tipoParticipacion;
  let tipoEquipoInicial = null;
  if (
    tipoParticipacion === TipoParticipacion.CLUBES ||
    tipoParticipacion === TipoParticipacion.REGION
  ) {
    tipoEquipoInicial = { codigo: TipoEquipo.CLUB, descripcion: 'Club' };
  } else if (
    tipoParticipacion === TipoParticipacion.PAIS ||
    tipoParticipacion === TipoParticipacion.SELECCIONES
  ) {
    tipoEquipoInicial = { codigo: TipoEquipo.SELECCION, descripcion: 'Selección' };
  }

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>Equipo</td>
        <td className={`${styles.valor}`}>
          <CampoBuscarEquipo
            nombre={Campos.TorneoParticipante.EQUIPO}
            valor={item?.equipo}
            editar={editar}
            width="80%"
            actualizar={actualizar}
            tipoInicial={tipoEquipoInicial}
            onEquipoElegido={onCampoChange}
          />
        </td>
      </tr>
      {!dePais && (
        <tr>
          <td className={`${styles.titulo}`}>Organizador</td>
          <td className={`${styles.valor}`}>
            <CampoEditableCheck
              nombre={Campos.TorneoParticipante.ORGANIZADOR}
              checked={item?.organizador || false}
              editar={editar}
              onChange={onCampoChange}
            />
          </td>
        </tr>
      )}
      <tr>
        <td className={`${styles.titulo}`}>Título Obtenido</td>
        <td className={`${styles.valor}`}>
          <CampoOptionsTitulo
            estilo={styles.options}
            nombre={Campos.TorneoParticipante.TITULO_OBTENIDO}
            valor={item?.tituloObtenido}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Movimiento Divisional</td>
        <td className={`${styles.valor}`}>
          <CampoOptionsMovimiento
            estilo={styles.options}
            nombre={Campos.TorneoParticipante.MOVIMIENTO_DIVISIONAL}
            valor={item?.movimientoDivisional}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Posición</td>
        <td className={`${styles.valor}`}>
          <CampoEditableNumero
            nombre={Campos.TorneoParticipante.POSICION_FINAL}
            valor={item?.posicionFinal}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Observaciones</td>
        <td className={`${styles.valor}`}>
          <CampoEditableMultilinea
            filas="3"
            columnas="50"
            nombre={Campos.TorneoParticipante.OBSERVACIONES}
            valor={item?.observaciones || ''}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CamposTorneoParticipante;
